import React, {useState, useRef, useEffect} from 'react';
import '../../styles/components.css'

const SelfieCapture = ({onCapture, onClose}) => {
    const videoRef = useRef(null);
    const [stream, setStream] = useState(null);
    const [error, setError] = useState('');
    const [isCameraReady, setCameraReady] = useState(false);

    useEffect(() => {
        startCamera();
        return () => stopCamera();
    }, []);

    const startCamera = async () => {
        try {
            const mediaStream = await navigator.mediaDevices.getUserMedia({
                video: {facingMode: 'user'}
            });

            if (videoRef.current) {
                videoRef.current.srcObject = mediaStream;
                setStream(mediaStream);
                setCameraReady(true);
                setError('');
            }
        } catch (err) {
            console.error('Error accessing camera:', err);
            setError('Could not access your camera. Please allow camera permissions.');
            setCameraReady(false);
        }
    };

    const stopCamera = () => {
        if (stream) {
            stream.getTracks().forEach(track => track.stop());
        }
    };

    const handleCapture = () => {
        if (!isCameraReady) return;

        const video = videoRef.current;
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        // Draw the video frame to the canvas
        const context = canvas.getContext('2d');
        context.drawImage(video, 0, 0, canvas.width, canvas.height);

        // Get the data URL from the canvas
        const dataUrl = canvas.toDataURL('image/jpeg');

        // Convert data URL to a file object
        const file = dataURLtoFile(dataUrl, 'selfie.jpg');

        // Stop the camera stream before calling onCapture
        stopCamera();

        // Call the onCapture callback with the file and preview URL
        onCapture(file, dataUrl);
    };

    const dataURLtoFile = (dataurl, filename) => {
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, {type: mime});
    };

    const handleClose = () => {
        // Make sure camera is stopped when closing
        stopCamera();
        onClose();
    };

    return (
        <div className="selfie-capture">
            <div className="selfie-header">
                <h2>Take Your Selfie</h2>
                <p>Position your face in the center of the frame</p>
            </div>

            {error && (
                <div className="camera-error">
                    <p>{error}</p>
                    <button className="button" onClick={startCamera}>
                        <i className="fa fa-refresh"></i> Retry
                    </button>
                </div>
            )}

            <div className="camera-container">
                <video
                    ref={videoRef}
                    autoPlay
                    playsInline
                    className="camera-view"
                />

                <div className="camera-overlay">
                    <div className="face-outline"></div>
                </div>
            </div>

            <div className="camera-controls">
                <button
                    className="button button-circle-camera"
                    onClick={handleCapture}
                    disabled={!isCameraReady}
                ><span className="capture-btn-inner"></span>
                </button>
            </div>

            <button className="button button-outlined camera-close" onClick={handleClose}>
                Cancel
            </button>

            <div className="info-text">
                <small>Please capture an image with your face clearly visible, ensuring good lighting without any
                    disruptions.</small>
            </div>
        </div>
    );
};

export default SelfieCapture;